import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  Exemption_8_1,
  Vessel
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";
import {sendQuery} from "../../../../../common/utils";

@Component({
    selector: 'app-visit-exemptions-exemption-8-1',
    templateUrl: './exemption_8_1.component.html',
    styleUrls: ['./exemption_8_1.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_8_1Component extends ExemptionBaseComponent {

  @Input() exemption: Exemption_8_1;

  OTHER: string = 'Other';

  portVisitUtils = PortvisitUtils;

  vessel: Vessel;

  searchVessel = term => sendQuery('com.portbase.bezoekschip.common.api.visit.FindVessels', {term: term});

  fuelTypes: string[] = ['',
    'LNG',
    'Methanol',
    'Ammonia',
    'Hydrogen',
    this.OTHER
  ];

  resetFuelTypeOther() {
    this.exemption.fuelTypeOther = '';
  }

  resetVesselInfo() {
    this.vessel = null;
    this.exemption.vesselENI = '';
    this.exemption.vesselIMO = '';
    this.exemption.vesselNameENI = '';
    this.exemption.vesselNameIMO = '';
  }
}
